export enum TreatmentState {
  Unplanned = 1,
  Scheduled = 2,
  Completed = 3,
  Returned = 4,
}
